import { useContext } from "react";
import { useLocation } from "react-router-dom";
import { AuthContext } from "../providers/AuthProvider";

//TODO ACHO QUE PRECISO FAZER ISSO RPAS OUTRAS FUNCOES
export function useActiveUser() {
  const { user, userSales } = useContext(AuthContext);
  const location = useLocation();

  const isSalesRoute = location.pathname.startsWith("/vendas");

  return {
    user: isSalesRoute ? userSales : user,
    isSales: isSalesRoute,
  };
}
